import React from 'react';
import LaborCostsTable from './labor-costs-table';
import MaterialCostsTable from './material-costs-table';
import SubcontractorCostsTable from './subcontractor-costs-table';

const SingleCostTypeTable = ({ 
  costType, 
  costDetails, 
  resourceAllocations, 
  handleViewPO, 
  handleViewWO,
  handleViewInvoice, 
  getAllocationCost, 
  formatHours 
}) => {
  
  // Material costs table
  if (costType === "material") {
    return (
        <MaterialCostsTable
            costDetails={costDetails}
            handleViewPO={handleViewPO}
            handleViewInvoice={handleViewInvoice}
        />
    )
  } 
  
  // Labor costs table
  if (costType === "labor") {
    return (
      <LaborCostsTable 
        resourceAllocations={resourceAllocations}
        getAllocationCost={getAllocationCost}
        formatHours={formatHours}
      />
    );
  }
  
  // Subcontractor costs table
  if (costType === "subcontractor") {
    return (
      <SubcontractorCostsTable 
        costDetails={costDetails}
        handleViewPO={handleViewPO}
        handleViewWO={handleViewWO}
        handleViewInvoice={handleViewInvoice}
      />
    );
  }
  
  return <div>No data available</div>;
};

export default SingleCostTypeTable; 